module.exports = __webpack_public_path__ + "img/合并.986d0061.svg";